import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eb5f880"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cook-bar" }
const _hoisted_2 = { class: "cook-cont" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cook-lb" }, "Cookie Policy", -1))
const _hoisted_4 = { class: "cook-cn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This website uses cookies to enhance user experience and to analyze performance and traffic on our website. We also share information in accordance with our Privacy Policy.", -1))
const _hoisted_6 = { class: "cook-ck" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_r_button = _resolveComponent("r-button")!
  const _component_r_icon = _resolveComponent("r-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_r_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlesave(true))),
          class: "btnacc",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Accept")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_r_icon, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlesave())),
          icon: "x",
          size: 25
        })
      ])
    ])
  ]))
}